import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'framework7-react';

import { ColumnView } from 'Containers';

import './style.scss';
import { Component } from '../../subviews';

const Page = props => {
  const {
    cities,
    components,
    currentCheckInAdress,
    currentFlowData,
    currentPageIndex,
    flowCountry,
    getLoqateAddress,
    id: pageId,
    invalidateComponent,
    isOffline,
    mode,
    name,
    pageIsInvalidOnNext,
    referenced_products,
    transient,
    updateCurrentFlowData,
    updateTransientProps,
    uploadResultFile,
    userFullName,
    validateComponent,
    validateOnlineBankAccount
  } = props;

  return name ? (
    <ColumnView justifyContent={'flex-start'} alignItems={'stretch'}>
      <List noHairlines>
        <ul>
          {components.map(component => (
            <Component
              cities={cities}
              component={component}
              componentFlowAgreementValue={currentFlowData[component.component_key]?.agreement || false}
              componentFlowData={currentFlowData[component.component_key] || {}}
              componentFlowValue={currentFlowData[component.component_key]?.value || ''}
              country={component?.country}
              currentCheckInAdress={currentCheckInAdress}
              currentPageIndex={currentPageIndex}
              flowCountry={flowCountry}
              forceUpdate={currentFlowData[component.component_key]?.forceUpdate}
              getLoqateAddress={getLoqateAddress}
              invalidateComponent={invalidateComponent}
              isDirty={currentFlowData[component.component_key]?.value !== undefined}
              isOffline={isOffline}
              isValid={currentFlowData[component.component_key]?.isValid}
              key={component.id}
              mode={mode}
              pageId={pageId}
              pageIsInvalidOnNext={pageIsInvalidOnNext}
              referenced_products={referenced_products}
              transient={transient}
              updateCurrentFlowData={updateCurrentFlowData}
              updateTransientProps={updateTransientProps}
              uploadResultFile={uploadResultFile}
              userFullName={userFullName}
              validateComponent={validateComponent}
              validateOnlineBankAccount={validateOnlineBankAccount}
              visible={currentFlowData[component.component_key]?.visible}
            />
          ))}
        </ul>
      </List>
    </ColumnView>
  ) : null;
};

Page.propTypes = {
  cities: PropTypes.array,
  components: PropTypes.array,
  currentCheckInAdress: PropTypes.array,
  currentFlowData: PropTypes.object,
  currentPageIndex: PropTypes.number,
  flowCountry: PropTypes.string,
  getLoqateAddress: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  invalidateComponent: PropTypes.func,
  isOffline: PropTypes.bool,
  mode: PropTypes.string,
  name: PropTypes.string,
  pageIsInvalidOnNext: PropTypes.bool,
  referenced_products: PropTypes.array,
  transient: PropTypes.object,
  updateCurrentFlowData: PropTypes.func,
  updateTransientProps: PropTypes.func,
  uploadResultFile: PropTypes.func,
  userFullName: PropTypes.string,
  validateComponent: PropTypes.func,
  validateOnlineBankAccount: PropTypes.func
};

export default Page;
